import PageLpService from '@/common/api/pageLp'
import {
  GET_PAGE_LP_PREVIEW
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_PAGE_LP_PREVIEW] (context, { code, params = {} }) {
    return new Promise((resolve, reject) => {
      PageLpService.getPreview(code, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
